import axios from 'axios';
import { DOMAIN_URL } from '../shared/constants';

const axiosInstance = axios.create({
    baseURL: DOMAIN_URL,
});

export default axiosInstance;
